import React from "react";
import { getNumberOfCartItems } from "../ShoppingCart/CartData";
import { setToaster } from "../Toaster";
import { ToastContainer } from "react-toastify";

interface Props {}

interface State {
  cartItemCount: number;
}

class CartItemBadge extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      cartItemCount: 0,
    };
  }

  //set the sleep duration
  sleep = (duration: any): Promise<any> => {
    return new Promise((resolve) => {
      setTimeout(resolve, duration);
    });
  };

  //main polling function
  poll = async (promiseFn: any, duration: any): Promise<any> => {
    //update the cart items badge number if changed
    let numberOfItems = getNumberOfCartItems("Cart");
    if (numberOfItems !== this.state.cartItemCount) {
      this.setState({ cartItemCount: numberOfItems }, () => {
        setToaster({
          state: { success: true },
          message: "Cart Updated",
        });
      });
    }
    //set up next poll
    promiseFn().then(
      this.sleep(duration).then(() => {
        this.poll(promiseFn, duration);
      })
    );
  };

  componentDidMount() {
    this.setState({ cartItemCount: getNumberOfCartItems("Cart") }, () => {
      // Call polling function
      this.poll(() => new Promise(() => null), 2000);
    });
  }

  render() {
    if (this.state.cartItemCount > 0) {
      return (
        <span className="badge badge-pill badge-light">
          {this.state.cartItemCount}
        </span>
      );
    } else {
      <></>;
    }
    <ToastContainer autoClose={2000} />;
  }
}

export default CartItemBadge;
